import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="Como jogar" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Adivinhe a palavra secreta em até 6 tentativas. Após cada palpite, a cor
        dos quadrados mudará para mostrar o quão perto o seu palpite estava da
        palavra.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="A"
          status="correct"
        />
        <Cell value="U" />
        <Cell value="D" />
        <Cell value="A" />
        <Cell value="Z" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        A letra A está na palavra e no local correto.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="O" />
        <Cell
          value="R"
          isRevealing={true}
          isCompleted={true}
          status="present"
        />
        <Cell value="D" />
        <Cell value="E" />
        <Cell value="M" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        A letra R está na palavra, mas no local errado.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="L" />
        <Cell value="I" />
        <Cell value="M" />
        <Cell isRevealing={true} isCompleted={true} value="B" status="absent" />
        <Cell value="O" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        A letra B não está na palavra em nenhum local.
      </p>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Os acentos são preenchidos automaticamente, e não são considerados nas dicas. <br/>
        As palavras podem possuir letras repetidas.
      </p>
  
      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
      Código adaptado de{' '}
        <a
          href="https://github.com/cwackerfuss/react-wordle"
          className="underline font-bold"
          target="_blank" rel="noreferrer"
        >
          Chase Wackerfuss
        </a>{' '}
      </p>
    </BaseModal>
  )
}
